import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface GetCard3DSType {
  data: [] | null;
  loading: boolean;
  error: string | null;
  get: (id: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useGetCard3DSStore = create<GetCard3DSType>((set) => ({
  loading: false,
  data: null,
  error: null,

  get: async (id, signal) => {
    try {
      set({ loading: true, data: null });
      const result = await CardsApi.getCard3ds(id, signal);
      set({ loading: false, data: result ?? null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, data: null, error: null }),
}));
